export default __webpack_public_path__ + "static/404-page-error-5f8fae5c2a33250349b1421ad1864f4b.svg";